import { useState, useEffect } from "react";
import "./styles.scss";

import EditIcon from "../../../Icon-SVG/EditIcon";

const Card = ({
  hostName,
  userName,
  macAdress,
  localIp,
  status,
  updateTime,
  icon,
  icon1,
  minHeight,
  customMargin,
  onClick,
  description,
  onDescriptionChange,
  isEditing,
  onEditClick,
  onCancelEdit,
}) => {
  const [descValue, setDescValue] = useState(description || "");

  useEffect(() => {
    setDescValue(description || "");
  }, [description]);

  const handleSave = () => {
    onDescriptionChange && onDescriptionChange(descValue);
  };

  const handleCancel = () => {
    setDescValue(description || "");
    onCancelEdit && onCancelEdit();
  };

  return (
    <div onClick={onClick} className={`agent__card border ${isEditing ? "editing" : ""}`}>
      <div className="agent__card-inner">
        <div className="agent__card-inner__icon">
          <div style={{ border: "none" }}>{icon}</div>
          <div>{icon1}</div>
        </div>
        <div className="agent__card-inner__text">
          {hostName && (
            <p className="agent__card-inner__text-value">
              <span>Host Name: </span>
              {hostName}
            </p>
          )}
          {userName && (
            <p className="agent__card-inner__text-value">
              <span>User: </span>
              {userName}
            </p>
          )}
          {macAdress && (
            <p className="agent__card-inner__text-value">
              <span>Mac: </span>
              {macAdress}
            </p>
          )}
          {localIp && (
            <p className="agent__card-inner__text-value">
              <span>Local IP: </span>
              {localIp}
            </p>
          )}
          {status && (
            <p className="agent__card-inner__text-value">
              <span>Status: </span>
              <span style={status === "Online" ? { color: "green" } : { color: "red" }}>
                {status}
              </span>
              <span style={{ marginLeft: "6px" }}>({updateTime})</span>
            </p>
          )}

          <div className="agent__card-inner__description">
            <span>Description: </span>
            {isEditing ? (
              <div className="description-edit-area">
                <textarea
                  value={descValue}
                  onChange={(e) => setDescValue(e.target.value)}
                  onClick={(e) => e.stopPropagation()}
                  rows={1}
                  className="autogrow"
                />
                <div className="description-buttons">
                  <button
                    className="save-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleSave();
                    }}>
                    Save
                  </button>
                  <button
                    className="cancel-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleCancel();
                    }}>
                    Cancel
                  </button>
                </div>
              </div>
            ) : (
              <div className="description-display">
                <p>{descValue || "----"}</p>
                <div
                  className="flex flex-align-items-center m-r-15"
                  onClick={(e) => {
                    e.stopPropagation();
                    onEditClick && onEditClick();
                  }}
                  style={{ cursor: "pointer" }}>
                  <EditIcon />
                  <p className="actions__button m-l-10">Edit</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
